import { defineAction } from '~/prix'
import { z } from 'zod'
import roadMaintenanceFetchAction from './roadMaintenanceFetch.action.json' with { type: 'json' }
import { roadMaintenanceObject } from '../roadMaintenanceObject'
import { operatorObject } from '../../operator/operatorObject'
import { materialObject } from '../../material/materialObject'
import { heavyMachineryObject } from '../../heavyMachinery/heavyMachineryObject'

const roadMaintenanceFetchDefinition = defineAction({
  ...roadMaintenanceFetchAction,

  input: z.object({
    id: roadMaintenanceObject.shape.id,
    includeDeleted: z.boolean().optional().default(false),
  }),
  output: roadMaintenanceObject.extend({
    materials: z.array(materialObject),
    machineUsages: z.array(
      z.object({
        heavyMachineryId: heavyMachineryObject.shape.id,
        operatorId: operatorObject.shape.id.nullish(),
        startTime: z.string().nullish(),
        endTime: z.string().nullish(),
      }),
    ),
  }),
})

export default roadMaintenanceFetchDefinition
